import merge from 'lodash/merge';
import { Theme } from '@mui/material/styles';
import TextFieldStyles from '@atoms/TextField/TextField.styles';
import ButtonStyle from '@atoms/Button/Button.styles';
import ProgressStyles from '@atoms/Progress/Progress.styles';
import MenuStyle from '@atoms/MenuItem/MenuItem.styles';
import PopoverStyle from '@atoms/Popover/Popover.styles';
import AvatarStyles from '@atoms/Avatar/Avatar.styles';
import CardStyles from '@atoms/Card/Card.styles';
import CardHeaderStyles from '@atoms/CardHeader/CardHeader.styles';
import TableStyles from '@molecules/Table/Table.styles';
import PaginationStyles from '@atoms/Pagination/Pagination.styles';
import AlertStyles from '@atoms/Alert/Alert.styles';
import TabStyles from '@atoms/Tab/Tab.styles';
import SwitchStyles from '@atoms/Switch/Switch.styles';

export function componentsOverrides(theme: Theme) {
  const components = merge(
    TextFieldStyles(theme),
    ButtonStyle(theme),
    ProgressStyles(theme),
    MenuStyle(theme),
    PopoverStyle(theme),
    AvatarStyles(theme),
    CardStyles(theme),
    CardHeaderStyles(theme),
    TableStyles(theme),
    PaginationStyles(theme),
    AlertStyles(theme),
    TabStyles(theme),
    SwitchStyles(theme),
  );

  return components;
}
